import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Laag-1",
		"serif:id": "Laag 1",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M2.306,21.693l19.387,-19.387",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.306,2.307l19.387,19.387",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		})]
	})
});
export default SvgCross;
